import { render, staticRenderFns } from "./HeaderAccount.vue?vue&type=template&id=0d64b6d8"
import script from "./HeaderAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderAccount.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderAccount.vue?vue&type=style&index=0&id=0d64b6d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports